
import { Base } from '@clients/myGeo';
import { Account } from '@/generated-clients/myProfile';
import { MaintenanceItem, MaintenanceItemType, MaintenanceItemUrgencyIndicatorEnum } from '@clients/bff';
import { TripLog } from '@clients/myTrips';
import IconCalender from '@components/icons/icon-calender.svg';
import IconReminderEdit from '@components/icons/icon-reminder-edit.svg';
import AppListItem, { ListItem } from '@components/new-styleguide/AppListItem.vue';
import { mapReminderTrigger } from '@util/reminderMapper';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import CarHealthBookAppointmentButton from '@components/car-health/CarHealthBookAppointmentButton.vue';

const TriplogModule = namespace('Triplog');
const ProfileModule = namespace('Profile');
const FavoriteModule = namespace('Favorite');
const GeographicsModule = namespace('Geographics')

@Component({
  name: 'CarHealthTabReminders',
  components: {
    IconCalender,
    IconReminderEdit,
    AppListItem,
    CarHealthBookAppointmentButton
  }
})
export default class CarHealthTabReminders extends Vue {
  @Prop({ default: false })
  private loading: boolean;

  @Prop({ required: true })
  private reminders: Array<MaintenanceItem>;

  @TriplogModule.Getter('getSelectedTriplog')
  private selectedTriplog: TripLog;

  private editReminder(reminder: MaintenanceItem) {
    return {
      name: 'maintenanceEdit',
      query: { vehicleId: String(this.selectedTriplog.vehicle.id) },
      params: { id: reminder.id }
    }
  }

  private showEditReminder(reminder: MaintenanceItem) {
    return reminder.itemType !== MaintenanceItemType.P57a;
  }

  private showBookAppointment(reminder: MaintenanceItem) {
    return reminder.itemType === MaintenanceItemType.Oil || reminder.itemType === MaintenanceItemType.P57a || reminder.itemType === MaintenanceItemType.WinterTire;
  }

  private getEditReminderClass(reminder: MaintenanceItem) {
    return `oeamtc-grid__item--${this.showBookAppointment(reminder) ? '6' : '12'}`;
  }

  private getBookAppointmentClass(reminder: MaintenanceItem) {
    return `oeamtc-grid__item--${this.showEditReminder(reminder) ? '6' : '12'}`;
  }

  private fillUrl(reminder) {
    if (reminder.urgencyIndicator === MaintenanceItemUrgencyIndicatorEnum.Overdue) {
      return 'url(#oeamtc-gradient__danger)';
    } else if (reminder.urgencyIndicator === MaintenanceItemUrgencyIndicatorEnum.Due) {
      return 'url(#oeamtc-gradient__warning)';
    }
    return 'url(#oeamtc-gradient__neutral)';
  }

  private switchId(reminder: MaintenanceItem) {
    return `done-${reminder.id}`;
  }

  get redirectToSettings() {
    return {
      name: 'maintenanceOverview',
      query: { vehicle: this.vehicleId.toString() }
    };
  }

  get createItem(): ListItem {
    return {
      title: 'Neue Erinnerung anlegen',
      tagIcon: { value: 'tag_plus', color: '#ccccc9', fill: 'black' },
      location: { name: 'maintenanceAdd', query: this.vehicleId ? { vehicleId: String(this.vehicleId) } : null }
    };
  }

  get vehicleId() {
    if (this.selectedTriplog && this.selectedTriplog.vehicle) {
      return this.selectedTriplog.vehicle.id;
    }
  }

  private textLines(value: MaintenanceItem) {
    const trigger = mapReminderTrigger(value);
    return [trigger.due, trigger.overdue, trigger.period].filter(value => value);
  }

}
